import { Outlet } from "react-router-dom";
import { useState } from "react";
import Sidebar from "../../components/agency/Sidebar";
import MobileMenuButton from "../../components/agency/MobileMenuButton";

export function AgencyLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="flex relative">
      {/* Mobile menu button */}
      <div className="fixed top-4 left-4 z-50 md:hidden">
        <MobileMenuButton onClick={toggleSidebar} />
      </div>

      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      {/* Main content */}
      <main className="flex-1 overflow-y-auto p-8 pt-12 md:p-8 md:ml-0">
        <Outlet />
      </main>
    </div>
  );
}
